import Backspace from '../../../assets/backspace.svg';

const BackspaceIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return <Backspace {...props} />;
};

export default BackspaceIcon;
